/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';

const Toggle = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    margin: '0px 8px',
    display: 'inline-flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.common.white,
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.link.main,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.common.white,
        borderColor: theme.palette.link.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.link.main}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.link.main,
  },
  checked: {},
}))(Switch);

export default Toggle;